import type { MouseEventHandler } from 'react';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import LoginIcon from '@atlaskit/icon/core/log-in';
import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';
import { EndItem } from '@atlaskit/navigation-system/top-nav-items';

import { START_TOUCH } from '@confluence/navdex/entry-points/NavdexPointType.ts';
import {
	useRouteDataRef,
	useRouteActions,
} from '@confluence/route-manager/entry-points/RouteState.ts';
import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context.ts';

const LOGIN_URL =
	typeof window !== 'undefined'
		? `${CONTEXT_PATH}/login.action?os_destination=${window.location.pathname.replace(
				CONTEXT_PATH,
				'',
			)}`
		: '';

export const LoginButton = (): React.JSX.Element => {
	const routeDataRef = useRouteDataRef();
	const { push } = useRouteActions();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const onClick: MouseEventHandler = (e) => {
		if (e.metaKey) {
			window.open(LOGIN_URL, '_blank', 'noreferrer');
		} else {
			push(LOGIN_URL);
		}

		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'login',
				attributes: {
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navVersion: '4',
					navdexPointType: START_TOUCH,
				},
			},
		}).fire();
	};

	return (
		<EndItem icon={LoginIcon} onClick={onClick} label={<FormattedMessage {...i18n.login} />} />
	);
};

const i18n = defineMessages({
	login: {
		id: 'app-navigation.top-navigation.login',
		defaultMessage: 'Log in',
		description: 'Label for the top navigation login button',
	},
});
